import React from 'react';

const AddCourseForm = ({ courseName, setCourseName, courseLink, setCourseLink, onAddOrUpdateCourse, isEditing, onCancel }) => {
    const isValidUrl = (url) => /^(https?:\/\/[^\s/$.?#].[^\s]*)$/i.test(url);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!courseName || !courseLink) {
            alert("Пожалуйста, заполните все поля.");
            return;
        }
        if (!isValidUrl(courseLink)) {
            alert("Пожалуйста, введите корректный URL (должен начинаться с http:// или https://).");
            return;
        }
        onAddOrUpdateCourse();
    };

    return (
        <div className="form-container">
            <h3>{isEditing ? 'Редактировать курс' : 'Добавить новый курс'}</h3>
            <form onSubmit={handleSubmit} className="course-form">
                <div className="form-group">
                    <label htmlFor="course-name">Название курса:</label>
                    <input
                        id="course-name"
                        type="text"
                        placeholder="Введите название курса"
                        value={courseName}
                        onChange={(e) => setCourseName(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="course-link">Ссылка на курс:</label>
                    <input
                        id="course-link"
                        type="text"
                        placeholder="Введите ссылку на курс"
                        value={courseLink}
                        onChange={(e) => setCourseLink(e.target.value)}
                    />
                </div>
                <div className="form-actions">
                    <button type="submit" className="submit-btn">
                        {isEditing ? 'Обновить курс' : 'Добавить курс'}
                    </button>
                    {isEditing && (
                        <button type="button" onClick={onCancel} className="cancel-btn">
                            Отмена
                        </button>
                    )}
                </div>
            </form>

            <style>{`
                .form-container {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 8px;
                    margin-top: 20px;
                }
                
                .form-container h3 {
                    margin-bottom: 15px;
                    color: #333;
                }
                
                .course-form {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                }
                
                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }
                
                .form-group label {
                    font-size: 14px;
                    color: #495057;
                }
                
                .form-group input {
                    padding: 10px 12px;
                    border: 1px solid #ced4da;
                    border-radius: 4px;
                    font-size: 14px;
                }
                
                .form-actions {
                    display: flex;
                    gap: 10px;
                    margin-top: 10px;
                }
                
                .submit-btn {
                    padding: 10px 15px;
                    background-color: #28a745;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                
                .submit-btn:hover {
                    background-color: #218838;
                }
                
                .cancel-btn {
                    padding: 10px 15px;
                    background-color: #dc3545;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                
                .cancel-btn:hover {
                    background-color: #c82333;
                }
            `}</style>
        </div>
    );
};

export default AddCourseForm;
